import React from "react";
import I18n from 'i18n.js.erb'
import { formatLocalizedDate } from '../../utils/utils'

// Il backoffice distingue la richiesta presa in carico da quella gia' approvata, ma al cliente
// interessa solo l'esito: finche' non c'e' un rimborso o un rifiuto la lavorazione e' in corso
const STATUS_KEY_BY_STATE = {
  received: 'inProgress',
  accepted: 'inProgress',
  refused: 'refused',
  refunded: 'completed'
}

const SubmissionListCancellationNotice = ({ cancellationRequest }) => {
  const statusKey = STATUS_KEY_BY_STATE[cancellationRequest.state]

  return (
    <div className="slx-notice">
      <h2 className="slx-section-title slx-notice__title">
        {I18n.t('js.editSubmissionListPage.cancellationNotice.title')}
      </h2>

      <p className="slx-notice__line">
        {I18n.t('js.editSubmissionListPage.cancellationNotice.summary', {
          number: cancellationRequest.number,
          date: formatLocalizedDate(cancellationRequest.created_at)
        })}
      </p>

      {statusKey &&
        <p className="slx-notice__line">
          {I18n.t(`js.editSubmissionListPage.cancellationNotice.status.${statusKey}`)}
        </p>
      }
    </div>
  );
};

export default SubmissionListCancellationNotice;
